import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { FiEye, FiEyeOff } from "react-icons/fi";
import "../../assets/css/ResetPassword.css";

const ResetPassword = () => {
  const [showPass, setShowPass] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  return (
    <div className="rp-wrapper">
      <Container fluid className="p-0">
        <Row className="g-0">

          {/* LEFT SIDE */}
          <Col lg={5} className="rp-left d-none d-lg-block">
            <div className="rp-left-inner">

              <img src="/assets/img/bg/bg-01.png" className="shape-1" alt="" />
              <img src="/assets/img/bg/bg-02.png" className="shape-2" alt="" />
              <img src="/assets/img/bg/bg-03.png" className="shape-3" alt="" />

              <div className="rp-card">
                <h1>
                  Empowering people <br />
                  through seamless HR <br />
                  management.
                </h1>

                <img
                  src="/assets/img/bg/authentication-bg-01.png"
                  className="rp-img"
                  alt=""
                />

                <p>
                  Efficiently manage your workforce, streamline <br />
                  operations effortlessly.
                </p>
              </div>
            </div>
          </Col>

          {/* RIGHT SIDE */}
          <Col lg={7} className="rp-right">
            <div className="rp-right-inner">

              {/* LOGO */}
              <div className="rp-logo">
                <img src="/assets/img/logo-1.svg" alt="" />
              </div>

              {/* FORM */}
              <div className="rp-form">
                <h2>Reset Password</h2>
                <p>
                  Your new password must be different from previous used passwords.
                </p>

                <Form>
                  {/* PASSWORD */}
                  <Form.Group className="mb-3 text-start">
                    <Form.Label>Password</Form.Label>

                    <div className="rp-input">
                      <Form.Control
                        type={showPass ? "text" : "password"}
                      />
                      <span onClick={() => setShowPass(!showPass)}>
                        {showPass ? <FiEye /> : <FiEyeOff />}
                      </span>
                    </div>

                    {/* Strength bars */}
                    <div className="rp-strength">
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>

                    <p className="rp-hint">
                      Use 8 or more characters with a mix of letters, numbers & symbols.
                    </p>
                  </Form.Group>

                  {/* CONFIRM PASSWORD */}
                  <Form.Group className="mb-3 text-start">
                    <Form.Label>Confirm Password</Form.Label>

                    <div className="rp-input">
                      <Form.Control
                        type={showConfirm ? "text" : "password"}
                      />
                      <span onClick={() => setShowConfirm(!showConfirm)}>
                        {showConfirm ? <FiEye /> : <FiEyeOff />}
                      </span>
                    </div>
                  </Form.Group>

                  <Button className="rp-btn">Submit</Button>
                </Form>
              </div>

              {/* FOOTER */}
              <div className="rp-footer">
                Copyright © 2026 - Smarthr
              </div>

            </div>
          </Col>

        </Row>
      </Container>
    </div>
  );
};

export default ResetPassword;